export default __webpack_public_path__ + "static/media/376.e71e8692.png";